import checkout, { createUserForm } from "./form";
import { ACTION_TYPE_ENUM } from "enums/action-type";

const {
  formField: {
    name,
    members,
    email,
    introduction,
    phone,
    taxCode,
    accountNumber,
    address,
    actionType,
    logo,
    bankBranch,
    bankOwner,
  },
} = checkout;

const {
  formField: { email: emailUser },
} = createUserForm;

const initialValuesCreateUser = {
  [emailUser.name]: "",
};

const initialValues = {
  [logo.name]: "",
  [name.name]: "",
  [phone.name]: "",
  [email.name]: "",
  [members.name]: "0",
  [taxCode.name]: "",
  [address.name]: "",
  [actionType.name]: ACTION_TYPE_ENUM.RESPONSE,
  [accountNumber.name]: "",
  [bankBranch.name]: "",
  [bankOwner.name]: "",
  [introduction.name]: "<p></p>",
};

export { initialValuesCreateUser };

export default initialValues;
